import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './other.json';

const getFunctionData = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['functionDataController/getFunctionData'].success.default)));
};

const getMetaDataTagByPath = (req, res, ctx) => {
  const responses = apiResponses['metaTagController/getMetaDataTagByPath'].success;
  return res(ctx.json(mockResponse(responses[req.body.path] || responses.default)));
};

const getCfgActivity = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['cfgActivityController/getCfgActivity'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('functionDataController/getFunctionData'), withScenario(withAuthCheck(getFunctionData))),
  rest.post(getApiEndpoint('metaTagController/getMetaDataTagByPath'), withScenario(getMetaDataTagByPath)),
  rest.post(getApiEndpoint('cfgActivityController/getCfgActivity'), withScenario(withAuthCheck(getCfgActivity))),
];
